import React from 'react'

import Text from 'App/components/text/Text.js'

export default function (props) {
  return (
    <Text {...props}><p>{props.children}</p></Text>
  )
}
